export default "__VITE_ASSET__vz0vP9aM__"